import { HttpClient } from '../../../shared/api/httpClient';
import { API_ENDPOINT } from '../../../shared/constanst/constants';
import { AxiosPromise } from 'axios';
//import { number, string } from 'prop-types';

const API_SLUG = 'Partes';

export interface Parte {
	idParte: number;
	dni: string;
	nombre: string;
	dn: string;
	codArea: string;
	codPais: string;
	idSociedad: string;
	idProyecto: number;
	idFuncion: number;
	fecha: string;
	nHoras: number;
	offShore: number;
	validadoArea: boolean;
  	validadoFiscal: boolean;
  	validadoFacturacion: boolean;
	numeroFactura: string;
	facturado: boolean;
	fechaFacturacion: string;
	area: string;
	pais: string;
	sociedad: string;
	proyecto: string;
	funcion: string;
	subFuncion: string;
	observaciones: string;
	tieneAdjuntos: boolean;
	multiplesSociedades: boolean;
	estado: number;
	abono: boolean;
}

export interface FiltroPartes{
	fechaDesde: string;
	fechaHasta: string;
	estado?: number;
	filterDrillDown: any;
}

interface NuevoParte{
	dni: string;
	dn: string;
	codArea: string;
	codPais: string;
	idSociedad: string;
	funcionesSubFunciones: any[];
	idProyecto: number;
	fechaDesde: string;
	fechaHasta: string;
	offShore?: number;
	incSab: boolean;
	incDom: boolean;
	observaciones: string;
}

// const blobToBase64 = (blob:any) => {
// 	return new Promise((resolve) => {
// 	  const reader = new FileReader();
// 	  reader.readAsDataURL(blob);
// 	  reader.onloadend = function () {
// 		resolve(reader.result);
// 	  };
// 	});
//   };

//  const getFiles64 = async(adjuntos:any) => {
// 	 let results:any = [];
// 	adjuntos.forEach(async (f:any)=>{
// 		let b64:any = await blobToBase64( new Blob([f.file]))
// 		if(b64!==undefined)
// 		{
// 			console.log('b64 ', b64)
// 			const data:any = {...{tipoAdjunto:f.tipoAdjunto},...{file:b64}}
// 			results.push(data);
// 		}
		
// 	 })
// 	 console.log('results ', results)
// 	 return [...results];
// 	//const jsonString = JSON.stringify({blob: b64});
// };

export class PartesAdapter {
	private cliente: HttpClient;

	constructor() {
		this.cliente = new HttpClient(API_ENDPOINT, API_SLUG);
	}

	ListarPartesValidacion(filtro: FiltroPartes): AxiosPromise<Parte[]> {
		return this.cliente.post(filtro, `/ListarPartesValidacion`);
	}

	ListarPartesDrillDown(filtro: FiltroPartes): AxiosPromise<Parte[]> {
		return this.cliente.post(filtro, `/ListarPartesDrillDown`);
	}

	ListarDetallePartes(filtro: FiltroPartes): AxiosPromise<Parte[]> {
		return this.cliente.post(filtro, `/ListarDetallePartes`);
	}

	ListarPartes(filtro: FiltroPartes): AxiosPromise<Parte[]> {
		return this.cliente.post(filtro, `/ListarPartes`);
	}

	ListarDatosPartesUsuarios(filtro: FiltroPartes): AxiosPromise<any[]> {
		return this.cliente.post(filtro, `/ListarDatosPartesUsuarios`);
	}

	ListarDatosFuncSub(filtro: FiltroPartes): AxiosPromise<any[]> {
		return this.cliente.post(filtro, `/ListarDatosFuncionesSubFunciones`);
	}

	CrearParte(parte:NuevoParte): AxiosPromise<Parte[]> {
		return this.cliente.post(parte, `/CrearPartes`);
	}

	CrearParteFinSemana(parte:any): AxiosPromise<Parte[]> {
		return this.cliente.post(parte, `/CrearPartesFinSemana`);
	}

	EliminarParte(id: number): AxiosPromise<any> {
		return this.cliente.remove(id, `/EliminarParte`);
	}

	EliminarPartes(ids: any): AxiosPromise<any> {
		return this.cliente.post(ids, `/EliminarPartes`);
	}

	ModificarParte(parte: Parte): AxiosPromise<Parte[]> {
		return this.cliente.put(parte.idParte, parte, `/ModificarParte`);
	}

	ModificarParteFinSemana(parte: Parte): AxiosPromise<Parte[]> {
		return this.cliente.put(parte.idParte, parte, `/ModificarParteFinSemana`);
	}

	AbonarPartes(idsPartes: string[]): AxiosPromise<any>{
		return this.cliente.post(idsPartes, `/AbonarPartes`);
	}

	AbonarPartesConConfiguracion(request: any): AxiosPromise<any>{
		return this.cliente.post(request, `/AbonarPartesConConfiguracion`);
	}

	async AdjuntarFicheros(data: any): Promise<AxiosPromise<any>> {
		var formData = new FormData();
		// Array.from(data.IdsPartes).forEach((IdParte: any) => {
		// 	formData.append("IdsPartes", IdParte.toString());
		// });

		// Array.from(data.adjuntos).forEach((file: any) => {
		// 	formData.append("files", file, file.name);
		// });

		const IdsPartes = data.IdsPartes;
		const Tipos = data.adjuntos.map((a:any)=> a.tipo.idTipoAdjunto);
		const Files = data.adjuntos.map((a:any)=>a.file);
		
		const result = {IdsPartes: IdsPartes, TiposAdjunto:Tipos}
		formData.append("request", JSON.stringify(result))

		Files.forEach((f: any) => {
			formData.append("Files", f);
		})
		
		return this.cliente.postFile(formData,`/AdjuntarFicheros`)
	}

	ValidarPartes(ids: any, tipo:string): AxiosPromise<any> {
		return this.cliente.post(ids, `/ValidarPartes/${tipo}`);
	}

	DesvalidarPartes(ids: any, tipo:string): AxiosPromise<any> {
		return this.cliente.post(ids, `/DesvalidarPartes/${tipo}`);
	}

	ImportarPartes(data: any): AxiosPromise<any> {
    const file = data[0];
		var formData = new FormData();
		formData.append("file", file, file.name);
		
		return this.cliente.postFile(formData, `/ImportarPartes`);
	}

	DescargarDatosUsuarios(ids: any): AxiosPromise<Blob> {
		return this.cliente.postDownloadFile(ids, `/DescargarDatosUsuarios`);
	}

}